module.exports = __webpack_public_path__ + "static/media/service5.e48c5b23.svg";